export const MODULE_CONTROL_DEFAULTS = {
  admissions:true, academics:true, students:true, staff:true, attendance:true, learning:true, exams:true,
  fees:true, finance:true, payroll:true, documents:true, certificates:true, live:true, clinical:true,
  transport:true, gatePass:true, library:true, inventory:true, uniform:true, communication:true, notifications:true, whatsapp:true, whatsappapi:true, smsgateway:true, discussion:true, meetings:true, securemessaging:true, lessonplans:true, website:true, reports:true,
  onlineAdmissions:true, counselling:true, promotion:true, documentRequests:true, biometric:true,
  feeAdvance:true, feeSplitPayments:true, feeCarryForward:true, approvalWorkflows:true,
  universalSearch:true, studentTimeline:true, familyProfile:true, internalTasks:true, supportChat:true, requisitions:true, offlineMode:true, backupRestore:true,
};

export const ADMISSION_POLICY_DEFAULTS = {
  requireApproval:true,
  duplicateCheck:true,
  documentVerification:true,
  admissionPaymentRequired:false,
  allowOfflineAdmission:true,
  allowOnlineAdmission:true,
  collectStudentPhoto:true,
  collectParentPhotos:false,
  collectMedicalDetails:true,
  collectPreviousEducation:true,
  collectTransportChoice:true,
  collectHostelChoice:false,
  autoAssignAdmissionNo:true,
  autoAssignStudentId:true,
  coachingCounsellorRequired:true,
  coachingBatchTimingRequired:true,
  coachingLeadTracking:true,
  coachingDemoTracking:true,
  coachingFeeNegotiation:true,
  schoolSiblingLinking:true,
  schoolPreviousSchoolRequired:false,
  collegeQualificationHistory:true,
  collegeSeatMatrix:true,
  nursingClinicalFields:true,
  onlineStartDate:'',
  onlineEndDate:'',
  allowedCourseIds:[],
  seatLimitEnabled:false,
  defaultSeatLimit:0,
  applicationFeeMode:'free',
  applicationFee:0,
  registrationFee:0,
  admissionFee:0,
};

export const PROMOTION_POLICY_DEFAULTS = {
  enabled:true,
  requireResult:false,
  allowWithFeeDue:true,
  carryForwardBalance:true,
  preserveRollNo:false,
  requireApproval:false,
  schoolAllowDetain:true,
  schoolAutoSection:false,
  collegeAllowBacklog:true,
  collegeAllowSemesterRepeat:true,
  coachingUseProgression:true,
};

export const FEE_POLICY_DEFAULTS = {
  advanceEnabled:true,
  splitPaymentEnabled:true,
  carryForwardEnabled:true,
  allowPartialPayment:true,
  allowOverpaymentToAdvance:true,
  concessionApproval:true,
  refundApproval:true,
  feeUnassignApproval:true,
  fineEnabled:true,
  scholarshipEnabled:true,
  previousBalanceSeparate:true,
  blockExamOnDue:false,
  blockPromotionOnDue:false,
  notifyDueDuringAttendance:true,
  accessLockEnabled:false,
  accessLockTrigger:'overdue',
  accessLockGraceDays:0,
  accessLockMinimumAmount:0,
  attendanceReminderCooldownHours:24,
  teacherCanSeeDueAmount:false,
  restrictedStudentFeatures:['results','certificates','digitalcourses','live'],
  coachingAdmissionPaymentMode:'percentage',
  coachingAdmissionPaymentValue:20,
  receiptCopies:'student',
  defaultDueDay:10,
  expectedCollectionDashboard:true,
  includePreviousOverdueInTarget:true,
  reminderDaysBefore:3,
  reminderDaysAfter:3,
  promiseToPayTracking:true,
};

export const DOCUMENT_POLICY_DEFAULTS = {
  certificateApproval:false,
  noDuesBeforeTransferCertificate:true,
  publicQrVerification:true,
  documentRequestsEnabled:true,
  documentVersioning:true,
  documentApproval:true,
  digitalSignature:true,
  allowCustomTemplates:true,
  defaultWatermark:true,
  principalSignatureRequired:false,
  certificateNumberPerType:true,
  archiveGeneratedPdf:true,
};

export const LIBRARY_POLICY_DEFAULTS = {
  enabled:true,
  usePhysicalCopies:true,
  barcodeEnabled:true,
  reservationsEnabled:true,
  finesEnabled:true,
  pushFineToStudentFees:false,
  defaultIssueDays:14,
  maxStudentBooks:3,
  maxStaffBooks:5,
  finePerDay:0,
  accessionPrefix:'LIB',
  accessionDigits:6,
  cameraScannerEnabled:true,
};

export const BIOMETRIC_POLICY_DEFAULTS = {
  enabled:false,
  provider:'Generic',
  mode:'push',
  duplicateWindowSeconds:60,
  studentMappingField:'admissionNo',
  staffMappingField:'employeeId',
  allowCsvImport:true,
  allowWebhook:true,
  markFirstScanIn:true,
  markLastScanOut:true,
};

export const TRANSPORT_POLICY_DEFAULTS = {
  enabled:true,
  autoAssignTransportFee:true,
  routeCapacityEnforced:true,
  vehicleCapacityEnforced:true,
  documentExpiryAlerts:true,
  allowMidSessionChange:true,
  requireDriverDocuments:true,
  studentBoardingTracking:false,
  autoCreateMonthlyFees:true,
  sessionStartMonth:4,
  feeDueDay:10,
};

export const GATE_POLICY_DEFAULTS = {
  enabled:true,
  requireApprovalForStudentExit:true,
  parentAuthorization:true,
  qrVerification:true,
  recordReturn:true,
  visitorPhoto:false,
  visitorIdProof:true,
  notifyParentOnExit:true,
};

export const REPORTING_POLICY_DEFAULTS = {
  pdfEnabled:true,
  csvEnabled:true,
  excelEnabled:false,
  showSensitiveFields:false,
  defaultSessionScope:'current',
  watermarkPdf:true,
  includeLogo:true,
  auditExports:true,
};

export const DATA_POLICY_DEFAULTS = {
  backupEnabled:true,
  restoreEnabled:true,
  resetEnabled:true,
  databaseDownloadEnabled:true,
  safetyBackupBeforeRestore:true,
  offlineEnabled:true,
  offlineFinancialWrites:false,
  conflictProtection:true,
  backupRetentionCount:10,
  bulkImportEnabled:true,
};

export const WORKFLOW_POLICY_DEFAULTS = {
  approvalsEnabled:true,
  internalTasks:true,
  documentRequests:true,
  supportChat:true,
  requisitions:true,
  requisitionApprovalRoles:['accountant','admin'],
  documentApprovalRoles:['admin'],
  notificationRouting:true,
  auditCriticalActions:true,
};

export const CLINICAL_POLICY_DEFAULTS = {
  attendanceEnabled:true,
  procedureLogEnabled:true,
  assessmentEnabled:true,
  internshipEnabled:true,
  hospitalPostingEnabled:true,
  wardDepartmentTracking:true,
};
